import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import EmergencyTab from "components/EmergencyTab";
import NotFound from "pages/NotFound";
import UserDashboard from './pages/user-dashboard';
import Homepage from './pages/homepage';
import ItineraryManagement from './pages/itinerary-management';
import TripPlanner from './pages/trip-planner';
import ItineraryBuilder from './pages/itinerary-builder';
import BookingsDashboard from './pages/bookings-dashboard';
import TripConfirmationCheckout from './pages/trip-confirmation-checkout';
import AcceptInvitation from './pages/accept-invitation';
import AdminDashboard from './pages/admin-dashboard';
import NotificationsCenter from './pages/notifications-center';
import BookingModification from './pages/booking-modification';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/itinerary/:tripId" element={<ItineraryManagement />} />
        <Route path="/accept-invitation" element={<AcceptInvitation />} />
        <Route path="/trip-planner" element={<TripPlanner />} />
        <Route path="/itinerary-builder" element={<ItineraryBuilder />} />
        <Route path="/bookings" element={<BookingsDashboard />} />
        <Route path="/booking-modification" element={<BookingModification />} />
        <Route path="/trip-confirmation-checkout" element={<TripConfirmationCheckout />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/notifications-center" element={<NotificationsCenter />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      <EmergencyTab />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
